module.exports = __webpack_public_path__ + "static/media/pickup_navy.898a4e67.svg";